import axios from "axios";
import { Client } from "@stomp/stompjs";

const baseUrl = "https://mototaksi.az:9898";
const WS_URL = "https://mototaksi.az:9898/ws";

let stompClient = null;
let messages = [];

const api = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

// ===================== WEBSOCKET =====================

export const connectToWebSocket = (onMessageReceived) => {
    stompClient = new Client({
        brokerURL: WS_URL,

        reconnectDelay: 5000,
        heartbeatIncoming: 20000,
        heartbeatOutgoing: 20000,

        onConnect: () => {
            console.log("✅ WS connected");

            stompClient.subscribe("/topic/sifarisqrupu", (message) => {
                if (!message.body) return;

                const parsed = JSON.parse(message.body);
                messages.push(parsed);
                onMessageReceived(parsed);
            });

            stompClient.subscribe("/topic/location", () => {});
        },

        onStompError: (frame) => {
            console.error("❌ STOMP error:", frame.headers?.message);
        },

        onWebSocketClose: () => {
            console.log("🔄 reconnecting...");
        },
    });

    stompClient.activate();
};

// ===================== WS SEND =====================

export const sendMessageToSocket = (chatMessage) => {
    if (!stompClient?.connected) return;

    stompClient.publish({
        destination: "/app/sendChatMessage",
        body: JSON.stringify(chatMessage),
    });
};

export const sendCourierLocation = (userId, lat, lon) => {
    if (!stompClient?.connected) return;

    stompClient.publish({
        destination: "/app/location",
        body: JSON.stringify({
            userId: Number(userId),
            latitude: lat,
            longitude: lon,
        }),
    });
};

// ===================== HELPERS =====================

export const getMessages = () => messages;

export const disconnectWebSocket = () => {
    if (stompClient) {
        stompClient.deactivate();
        stompClient = null;
    }
};

// ===================== ADMIN =====================

export const getAdmins = () => api.get("/api/v5/admin");
export const createAdmin = (admin) => api.post("/api/v5/admin", admin);
export const deleteAdmin = (adminId) =>
    api.delete(`/api/v5/admin/${adminId}`);

export const getCustomAdmin = (adminId) =>
    api.get(`/api/v5/admin/${adminId}`);

export const updateAdmin = (adminId, admin) =>
    api.put(`/api/v5/admin/${adminId}`, admin);

// ===================== NOTIFICATION =====================

export const getNotifications = () => api.get("/api/v5/notification");
export const getCustomNotification = (id) =>
    api.get(`/api/v5/notification/${id}`);

export const createNotification = (data) =>
    api.post("/api/v5/notification", data);

export const updateNotification = (id, data) =>
    api.put(`/api/v5/notification/${id}`, data);

export const deleteNotification = (id) =>
    api.delete(`/api/v5/notification/${id}`);

// ===================== BANNER =====================

export const getBanners = () => api.get("/api/v5/banner");
export const getCustomBanner = (id) =>
    api.get(`/api/v5/banner/${id}`);

export const createBanner = (data) =>
    api.post("/api/v5/banner", data);

export const updateBanner = (id, data) =>
    api.put(`/api/v5/banner/${id}`, data);

export const deleteBanner = (id) =>
    api.delete(`/api/v5/banner/${id}`);

// ===================== CHAT GROUP =====================

export const getChatGroups = () => api.get("/api/v5/chat_group");

export const getChatGroupById = (id) =>
    api.get(`/api/v5/chat_group/${id}`);

export const createChatGroup = (data) =>
    api.post("/api/v5/chat_group", data);

export const updateChatGroup = (id, data) =>
    api.put(`/api/v5/chat_group/${id}`, data);

export const deleteChatGroup = (id) =>
    api.delete(`/api/v5/chat_group/${id}`);

// ===================== ELAN =====================

export const getElans = () => api.get("/api/v5/elan");

export const getElanById = (id) =>
    api.get(`/api/v5/elan/${id}`);

export const createElan = (data) =>
    api.post("/api/v5/elan", data);

export const updateElan = (id, data) =>
    api.put(`/api/v5/elan/${id}`, data);

export const deleteElan = (id) =>
    api.delete(`/api/v5/elan/${id}`);

// ===================== USTA =====================

export const getUstas = () => api.get("/api/v5/usta");

export const getUstaById = (id) =>
    api.get(`/api/v5/usta/${id}`);

export const createUsta = (data) =>
    api.post("/api/v5/usta", data);

export const updateUsta = (id, data) =>
    api.put(`/api/v5/usta/${id}`, data);

export const deleteUsta = (id) =>
    api.delete(`/api/v5/usta/${id}`);

// ===================== CHAT =====================

export const getChats = (params) =>
    api.get("/api/chats", { params });

export const getCustomChat = (id) =>
    api.get(`/api/chat/${id}`);

export const createChat = (data) =>
    api.post("/api/chat", data);

export const updateChat = (id, data) =>
    api.put(`/api/chat/${id}`, data);

export const deleteChat = (id) =>
    api.delete(`/api/chat/${id}`);

// ===================== USER =====================

export const getUsers = () => api.get("/api/v5/user");

export const getCustomUser = (id) =>
    api.get(`/api/v5/user/${id}`);

export const loginUser = (data) =>
    api.post("/api/v5/login/user", data);

export const createUser = (data) =>
    api.post("/api/v5/user", data);

export const updateUser = (id, data) =>
    api.put(`/api/v5/user/${id}`, data);

export const deleteUser = (id) =>
    api.delete(`/api/v5/user/${id}`);

// ===================== ORDER =====================

export const getAllOrders = async () => {
    const res = await api.get("/api/v5/order");
    return res.data;
};

export const getOrderById = async (id) => {
    const res = await api.get(`/api/v5/order/${id}`);
    return res.data;
};

export const createOrder = async (data) => {
    const res = await api.post("/api/v5/order", data);
    return res.data;
};

export const updateOrder = async (id, data) => {
    const res = await api.put(`/api/v5/order/${id}`, data);
    return res.data;
};

export const deleteOrder = async (id) => {
    const res = await api.delete(`/api/v5/order/${id}`);
    return res.data;
};

// ===================== SUPER ADMIN =====================

export const getSuperAdmins = () => api.get("/api/v5/superAdmin");

export const getCustomSuperAdmin = (id) =>
    api.get(`/api/v5/superAdmin/${id}`);

export const createSuperAdmin = (data) =>
    api.post("/api/v5/superAdmin", data);

export const updateSuperAdmin = (id, data) =>
    api.put(`/api/v5/superAdmin/${id}`, data);

// ===================== PAYMENT =====================

export const initPayment = (data) =>
    api.post("/api/v5/payment-init", data);

export default api;
